import React from 'react';
import * as icons from '../../assets/icons';
import './footer.less';

const Footer = () => {
  const scrollToSection = (selector, techTab) => {
    if (techTab) {
      window.dispatchEvent(
        new CustomEvent('geekcode:switch-tech-tab', { detail: { tab: techTab } })
      );
    }
    const el = document.querySelector(selector);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 76;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-container">
        <div className="footer-main">
          <div className="footer-brand">
            <img src={icons.logo1} alt="IDEVault" className="footer-logo" />
            <p className="footer-desc">
              安全可控的企业级专有云研发与外包协作平台 · 代码不落地 · 内置双 AI 智能体
            </p>
          </div>

          <div className="footer-links">
            <h2>产品</h2>
            <button type="button" onClick={() => scrollToSection('#features')}>
              核心能力
            </button>
            <button type="button" onClick={() => scrollToSection('#tech', 'ai')}>
              AI 智能体
            </button>
            <button type="button" onClick={() => scrollToSection('#tech', 'security')}>
              安全与合规
            </button>
            <button type="button" onClick={() => scrollToSection('#use-cases')}>
              应用场景
            </button>
            <button type="button" onClick={() => scrollToSection('#deployment')}>
              部署与交付
            </button>
            <a
              href="https://console.geekcode.cloud/login/"
              target="_blank"
              rel="noopener noreferrer"
            >
              登录控制台 ↗
            </a>
          </div>

          <div className="footer-contact">
            <h2>联系方式</h2>
            <ul>
              <li>
                <span>深圳</span>
                <span>福田区大庆大厦</span>
              </li>
              <li>
                <span>电话</span>
                <a href="tel:+8615910755004">15910755004</a>
              </li>
              <li>
                <span>邮箱</span>
                <a href="mailto:tai.wang@geeklamp.io">tai.wang@geeklamp.io</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copy-right">
            Copyright &copy; {new Date().getFullYear()} 深圳阿拉丁五人科技有限公司 · IDEVault 企业专有云研发环境 |{' '}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://beian.miit.gov.cn/"
            >
              粤ICP备2022119416号
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
